export enum FgDamageLevelEnum{
    PALLET='PALLET',
    CARTON='CARTON'
}